import { render, staticRenderFns } from "./DSSelect.vue?vue&type=template&id=984f0b94&scoped=true&"
import script from "./DSSelect.vue?vue&type=script&lang=js&"
export * from "./DSSelect.vue?vue&type=script&lang=js&"
import style0 from "./DSSelect.vue?vue&type=style&index=0&id=984f0b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984f0b94",
  null
  
)

export default component.exports